import React from "react";
import './call_timing.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";

const rangeStyle = (rangeVal) => {
    console.log('rangeval ', rangeVal)
    return {
        point: {
            left: `calc(${rangeVal * (100/10)}% + ${0}px)`
        },
        range: {
            width: `${rangeVal * (100/10)}%`
        },
        translate: {
            transform: `translateX(-${rangeVal * (100/10)}%)`
        }
    };
}

class CallTiming extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            rangeValue: 0
        }
    }

    handleChange = (rangeValue, e) => {
        console.log(e.target.value)
        this.setState({
            valRangeBar: e.target.value
        });

    }

    componentRender(data) {
        const slideS = rangeStyle(this.state.valRangeBar);
        return (
            <div id={"call-timing"}>
                <div className="call-timing-container">
                    <h3 className={"title"}>{data.title}</h3>
                    <div className={'table-wrap'} style={slideS.translate}>
                        <table className="table-call-timing">
                            <tbody>
                            {data.row_simple.map((el, index) =>(
                                <tr key={index} className={''}>
                                    <td className={'col-md-7'}>{el.title}</td>
                                    <td className={'col-md-5'}>{el.timing}</td>
                                </tr>
                            ))
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={'range'}>
                    <span className="range-value" style={slideS.range} />
                    <span className="circle" style={slideS.point} />
                    <input
                        className="range-slide"
                        name="range"
                        type="range"
                        min="0"
                        max="8"
                        value="10"
                        step="1"
                        onChange={this.handleChange.bind(this, this.rangeValue)}
                    />
                </div>
            </div>
        )
    }
}

export default CallTiming;